import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#B07A8F',
      light: '#C9A2B2',
      dark: '#8E5C72',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#C9A96E',
      light: '#DDBF8E',
      dark: '#A68845',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#6B9E78',
    },
    warning: {
      main: '#D4A84E',
    },
    error: {
      main: '#C26A6A',
    },
    info: {
      main: '#6A8EB0',
    },
    grey: {
      50: '#FAF8F6',
      100: '#F2EEEA',
      200: '#E4DED8',
      400: '#B5ADA5',
      600: '#7A7269',
      800: '#3D3731',
      900: '#2A2520',
    },
    background: {
      default: '#FAF8F6',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#3D3731',
      secondary: '#7A7269',
    },
  },
  typography: {
    fontFamily: '"DM Sans", sans-serif',
    h4: {
      fontFamily: '"Cormorant Garamond", serif',
      fontWeight: 600,
      fontSize: '2.125rem',
    },
    h5: {
      fontFamily: '"Cormorant Garamond", serif',
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h6: {
      fontFamily: '"Cormorant Garamond", serif',
      fontWeight: 600,
      fontSize: '1.3rem',
    },
    subtitle2: {
      fontFamily: '"Cormorant Garamond", serif',
      fontWeight: 600,
      letterSpacing: '0.02em',
    },
    body1: {
      fontWeight: 400,
      fontSize: '1rem',
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.875rem',
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      letterSpacing: '0.02em',
    },
    button: {
      fontWeight: 500,
      fontSize: '0.875rem',
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: '1px solid #E4DED8',
          background: 'linear-gradient(145deg, #FFFFFF 0%, #FDFBF9 100%)',
          boxShadow: '0 2px 8px rgba(176,122,143,0.06)',
          padding: 24,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none' as const,
          transition: 'all 0.2s ease',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(176,122,143,0.15)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
        },
        contained: {
          background: 'linear-gradient(135deg, #B07A8F 0%, #C9A2B2 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #A06D82 0%, #B8919F 100%)',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined' as const,
        size: 'small' as const,
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            transition: 'box-shadow 0.2s ease',
            '&:hover': {
              boxShadow: '0 0 0 3px rgba(176,122,143,0.08)',
            },
            '&.Mui-focused': {
              boxShadow: '0 0 0 3px rgba(176,122,143,0.15)',
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 20,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          overflow: 'hidden',
          boxShadow: '0 8px 32px rgba(62,55,49,0.12)',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontFamily: '"Cormorant Garamond", serif',
          fontWeight: 600,
          fontSize: '1.35rem',
          background: 'linear-gradient(135deg, rgba(176,122,143,0.08) 0%, rgba(201,169,110,0.06) 100%)',
          borderBottom: '1px solid #E4DED8',
          paddingBottom: 12,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          '.MuiDialogTitle-root + &': {
            paddingTop: 20,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
});

export default theme;
